<!-- Special Offers and Promotions -->
<ng-container *ngIf="!pricingForCompareDevice">
  <!-- Full Retail Price -->
  <ng-template #displayExactPrice>
    <div class="row" [ngClass]="{ 'm-t-md m-b-md': isAccessoriesCarousel && isProductSelector }">
      <ng-content></ng-content>
      <div class="col-12" [ngClass]="isBrowseDevice ? 'ps-0' : ''">
        <h2
          id="pricing-panel_{{ id }}"
          *ngIf="!isAccessoriesCarousel"
          [ngClass]="isCompare ? 'n3' : 'n1'"
          class="price-text"
        >
          <sup [ngClass]="isCompare ? 'n4' : 'n2'">{{ currency }}</sup
          >{{ monthlyWholeNumber
          }}<sup [ngClass]="isCompare ? 'n4' : 'n2'">{{ monthlyDecimalNumber }}</sup>
        </h2>
        <p id="pricing-panel_{{ id }}" class="content small m-t-md" *ngIf="isAccessoriesCarousel">
          <sup class="n2">{{ currency }}</sup
          >{{ wholeNumber }}<sup class="n2">{{ decimalNumber }}</sup>
        </p>
      </div>
    </div>
    <div class="row" *ngIf="isEpin">
      <div class="col-12">
        <p class="m-t-xs xsmall">{{ aemContent?.dueToday }}</p>
      </div>
    </div>
  </ng-template>
  <div class="row" *ngIf="!selectedEipAmount && isEpin; else displayExactPrice">
    <div class="col-12" [ngClass]="isBrowseAccessory ? 'm-t-sm' : 'm-t-lg'">
      <div class="">
        <h2 id="pricing-panel_{{ id }}" class="price-text n1 inline-block">
          <sup class="n2">{{ currency }}</sup
          >{{ minEpinWholeNumber }}<sup class="n2">{{ minEpinDecimalNumber }}</sup>
        </h2>
        <h2 id="pricing-panel_{{ id }}" class="price-text n1 inline-block">{{ hyphen }}</h2>
        <h2 id="pricing-panel_{{ id }}" class="price-text n1 inline-block">
          <sup class="n2">{{ currency }}</sup
          >{{ maxEpinWholeNumber }}<sup class="n2">{{ maxEpinDecimalNumber }}</sup>
        </h2>
      </div>
      <div class="row">
        <div class="col-12">
          <p class="m-t-xs xsmall">{{ aemContent?.dueToday }}</p>
        </div>
      </div>
    </div>
  </div>
  <!-- Disclaimer -->
  <div class="row" *ngIf="withoutServicePriceDisclaimer">
    <div class="col-12">
      <p class="xsmall">{{ withoutServicePriceDisclaimer }}</p>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="pricingForCompareDevice">
  <h2 id="pricing-panel_{{ id }}" class="price-text n1 m-r-md">
    <sup class="n2">{{ deviceDetails?.payNowPrice }}</sup
    >{{ deviceDetails.payNowPrice }}<sup class="n2">{{ deviceDetails?.payNowPrice }}</sup>
  </h2>
</ng-container>
